export enum SubscriptionTokenEnums {
	REVIEW_SUBMITTED = 'review_submitted'
}
